const ISO_DURATION = /^P(?:(\d+(?:[.,]\d+)?)D)?(?:T(?:(\d+(?:[.,]\d+)?)H)?(?:(\d+(?:[.,]\d+)?)M)?(?:(\d+(?:[.,]\d+)?)S)?)?$/i;
function num(v) {
    return v ? Number(v.replace(',', '.')) : 0;
}
/** Parse an ISO 8601 duration (PT1H30M) to whole minutes, or null. */
export function parseIsoDurationMinutes(value) {
    if (!value)
        return null;
    const m = value.trim().match(ISO_DURATION);
    if (!m)
        return null;
    const minutes = num(m[1]) * 1440 + num(m[2]) * 60 + num(m[3]) + num(m[4]) / 60;
    if (!Number.isFinite(minutes))
        return null;
    return Math.round(minutes);
}
const TEXT_UNITS = [
    [/\b(\d+(?:[.,]\d+)?)\s*(?:h|hr|hrs|hour|hours|std\.?|stunde|stunden)\b/gi, 60],
    [/\b(\d+(?:[.,]\d+)?)\s*(?:m|min|mins|minute|minutes|minuten)\b/gi, 1],
    [/\b(\d+(?:[.,]\d+)?)\s*(?:s|sec|secs|second|seconds|sek|sekunden)\b/gi, 1 / 60],
    [/\b(\d+(?:[.,]\d+)?)\s*(?:d|day|days|tag|tage)\b/gi, 1440],
];
/**
 * Parse human durations such as "45 minutes", "1 hour 30 minutes", "1 Std. 30 Min.",
 * "1h30", "PT45M", "overnight" (-> 480). Returns whole minutes or null.
 */
export function parseDurationMinutes(value) {
    if (value === null || value === undefined)
        return null;
    if (typeof value === 'number')
        return Number.isFinite(value) && value >= 0 ? Math.round(value) : null;
    const text = value.trim();
    if (!text)
        return null;
    const iso = parseIsoDurationMinutes(text);
    if (iso !== null)
        return iso;
    if (/^\d+$/.test(text))
        return Number(text);
    const compact = text.match(/^(\d+)\s*h\s*(\d+)$/i);
    if (compact)
        return Number(compact[1]) * 60 + Number(compact[2]);
    const clock = text.match(/^(\d{1,2}):(\d{2})$/);
    if (clock)
        return Number(clock[1]) * 60 + Number(clock[2]);
    if (/\b(overnight|über nacht|ueber nacht)\b/i.test(text))
        return 480;
    let total = 0;
    let matched = false;
    for (const [re, factor] of TEXT_UNITS) {
        re.lastIndex = 0;
        let m;
        while ((m = re.exec(text)) !== null) {
            total += Number(m[1].replace(',', '.')) * factor;
            matched = true;
        }
    }
    return matched ? Math.round(total) : null;
}
/** "1 h 30 min" / "45 min" for de or en. */
export function formatMinutes(minutes, locale = 'en') {
    if (minutes === null || minutes === undefined)
        return '';
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    const hu = locale === 'de' ? 'Std.' : 'h';
    const mu = 'min';
    if (h > 0 && m > 0)
        return `${h} ${hu} ${m} ${mu}`;
    if (h > 0)
        return `${h} ${hu}`;
    return `${m} ${mu}`;
}
/** Extract a step timer duration in seconds from an instruction ("bake for 45 minutes"). */
export function extractDurationSeconds(instruction) {
    const m = instruction.match(/(\d+(?:[.,]\d+)?)(?:\s*(?:-|–|to|bis)\s*(\d+(?:[.,]\d+)?))?\s*(h|hr|hrs|hour|hours|std\.?|stunde|stunden|min|mins|minute|minutes|minuten|sec|secs|second|seconds|sek|sekunden)\b/i);
    if (!m)
        return null;
    const unit = m[3].toLowerCase();
    const value = Number((m[2] ?? m[1]).replace(',', '.'));
    if (/^(h|hr|hrs|hour|hours|std|std\.|stunde|stunden)$/.test(unit))
        return Math.round(value * 3600);
    if (/^(sec|secs|second|seconds|sek|sekunden)$/.test(unit))
        return Math.round(value);
    return Math.round(value * 60);
}
//# sourceMappingURL=duration.js.map